import React from 'react';
import { Modal, StyleSheet, Text, TouchableOpacity, TouchableWithoutFeedback, View, } from 'react-native';
import { shadowStyle } from './styles';
import { theme } from '../theme';
export const ClientActionsMenu = ({ visible, onClose, items, }) => {
    if (!visible) {
        return null;
    }
    return (<Modal visible={visible} transparent={true} animationType="fade" onRequestClose={onClose}>
      <TouchableWithoutFeedback onPress={onClose}>
        <View style={styles.overlay}>
          <TouchableWithoutFeedback onPress={e => e.stopPropagation()}>
            <View style={styles.menuContainer}>
              {items.map((item, index) => (<TouchableOpacity key={index} style={[
                styles.menuItem,
                index === items.length - 1 && styles.menuItemLast,
                item.danger && styles.menuItemDanger,
            ]} onPress={() => {
                item.onPress();
                onClose();
            }}>
                  <Text style={[
                styles.menuItemText,
                item.danger && styles.menuItemTextDanger,
            ]}>
                    {item.label}
                  </Text>
                </TouchableOpacity>))}
            </View>
          </TouchableWithoutFeedback>
        </View>
      </TouchableWithoutFeedback>
    </Modal>);
};
const styles = StyleSheet.create({
    overlay: {
        flex: 1,
        backgroundColor: theme.colors.overlayMenu,
        justifyContent: 'center',
        alignItems: 'center',
    },
    menuContainer: {
        backgroundColor: theme.colors.surfaceElevated,
        borderRadius: 8,
        minWidth: 200,
        ...shadowStyle(0, 2, 3.84, 0.25),
        elevation: 5,
        overflow: 'hidden',
    },
    menuItem: {
        paddingVertical: 12,
        paddingHorizontal: 16,
        borderBottomWidth: 1,
        borderBottomColor: theme.colors.surfaceProgressTrack,
    },
    menuItemLast: {
        borderBottomWidth: 0,
    },
    menuItemDanger: {
        backgroundColor: theme.colors.surfaceWarningMuted,
    },
    menuItemText: {
        fontSize: 16,
        color: theme.colors.textTitle,
    },
    menuItemTextDanger: {
        color: theme.colors.danger,
    },
});
